var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-body"},[_c('font-awesome-icon',{staticClass:"rotating",attrs:{"icon":"circle-notch"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }